import apiWorker from '../apiWorker'

const flows = {
    generate: (data) => apiWorker('post',  `/v1/flows/generate_template`, data),
}

export default flows;